import { render, staticRenderFns } from "./exploreHome.vue?vue&type=template&id=a2fc5efa&scoped=true&"
import script from "./exploreHome.vue?vue&type=script&lang=js&"
export * from "./exploreHome.vue?vue&type=script&lang=js&"
import style0 from "./exploreHome.vue?vue&type=style&index=0&id=a2fc5efa&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2fc5efa",
  null
  
)

export default component.exports